(function () {
  class PetesPerksCarousel extends HTMLElement {
    static get observedAttributes() {
      return ['data-pack-size'];
    }

    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-perks-track]');
      this.previousButton = this.querySelector('[data-perks-prev]');
      this.nextButton = this.querySelector('[data-perks-next]');
      this.status = this.querySelector('[data-perks-status]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.stopLabelClick = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };

      [this.previousButton, this.nextButton].forEach(
        function (button) {
          if (!button) return;
          button.addEventListener('pointerdown', this.stopLabelClick);
          button.addEventListener('click', this.stopLabelClick);
        }.bind(this)
      );

      if (this.previousButton) {
        this.previousButton.addEventListener('click', this.moveByPage.bind(this, -1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.moveByPage.bind(this, 1));
      }
      if (this.track) {
        this.track.addEventListener('scroll', this.updateNavigation.bind(this), { passive: true });
        this.track.addEventListener('keydown', this.handleTrackKeydown.bind(this));
      }

      this.context = this.dataset.perksMode === 'builder'
        ? this.closest('pdp-bundle-builder')
        : this.closest('[data-simple-pdp]');
      if (this.context) {
        this.context.addEventListener('change', this.queueContextUpdate.bind(this));
        this.context.addEventListener('click', this.queueContextUpdate.bind(this));
      }

      this.update(false, false);
      window.requestAnimationFrame(
        function () {
          this.moveToPack(this.packSize(), false);
          this.updateNavigation();
        }.bind(this)
      );
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name !== 'data-pack-size' || oldValue === newValue || this.dataset.ready !== 'true') return;
      this.update(true, true);
    }

    queueContextUpdate() {
      window.requestAnimationFrame(
        function () {
          var nextPack = this.contextPackSize();
          if (nextPack !== this.packSize()) {
            this.setAttribute('data-pack-size', String(nextPack));
          } else {
            this.moveToPack(nextPack, true);
          }
        }.bind(this)
      );
    }

    contextPackSize() {
      if (!this.context) return this.packSize();
      if (this.dataset.perksMode === 'builder') {
        var count = Array.from(this.context.querySelectorAll('[data-pdpb-count]')).reduce(function (total, element) {
          return total + (Number(element.textContent) || 0);
        }, 0);
        if (count >= 12) return 12;
        if (count >= 6) return 6;
        return Number(this.dataset.basePack) || 4;
      }

      var selected = Array.from(this.context.querySelectorAll('[data-simple-option-group] input:checked'))
        .map(function (input) {
          return input.value;
        })
        .join(' ');
      var match = selected.match(/(?:^|\D)(3|6|12)(?:\D|$)/);
      return match ? Number(match[1]) : Number(this.dataset.basePack) || 3;
    }

    packSize() {
      return Number(this.dataset.packSize) || Number(this.dataset.basePack) || 3;
    }

    update(announce, move) {
      var pack = this.packSize();
      var value = 0;
      var count = 0;

      this.querySelectorAll('[data-perks-card]').forEach(function (card) {
        var minimum = Number(card.dataset.minPack) || 3;
        var unlocked = pack >= minimum;
        var badge = card.querySelector('[data-perks-badge]');
        var label = unlocked ? card.dataset.unlockedLabel : card.dataset.lockedLabel;
        card.classList.toggle('is-unlocked', unlocked);
        card.classList.toggle('is-locked', !unlocked);
        card.setAttribute('aria-disabled', String(!unlocked));
        card.setAttribute('aria-label', card.dataset.title + ', ' + label);
        if (badge) badge.textContent = label;
        if (unlocked) {
          value += Number(card.dataset.perkValue) || 0;
          count += 1;
        }
      });

      var valueLabel = '$' + value;
      var total = this.querySelector('[data-perks-total]');
      if (total) total.textContent = valueLabel;
      if (announce && this.status) {
        this.status.textContent = (this.dataset.statusTemplate || '')
          .replace('__PACK__', String(pack))
          .replace('__COUNT__', String(count))
          .replace('__VALUE__', valueLabel);
      }
      if (move) this.moveToPack(pack, true);
    }

    moveToPack(pack, smooth) {
      if (!this.track || !this.track.clientWidth) return;
      var cards = Array.from(this.querySelectorAll('[data-perks-card]'));
      if (!cards.length) return;
      var targetIndex = 0;
      if (pack >= 12) {
        targetIndex = cards.length - 1;
      } else if (pack >= 6) {
        targetIndex = cards.findIndex(function (card) {
          return Number(card.dataset.minPack) === 6;
        });
      }
      if (targetIndex < 0) targetIndex = 0;
      var maxLeft = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      var targetLeft = pack >= 12
        ? maxLeft
        : Math.min(maxLeft, Math.max(0, cards[targetIndex].offsetLeft - cards[0].offsetLeft));
      this.track.scrollTo({
        left: targetLeft,
        behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'auto',
      });
      window.requestAnimationFrame(this.updateNavigation.bind(this));
    }

    moveByPage(direction) {
      if (!this.track) return;
      var maxLeft = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      var targetLeft = Math.max(0, Math.min(maxLeft, this.track.scrollLeft + direction * this.track.clientWidth));
      this.track.scrollTo({
        left: targetLeft,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
      });
    }

    handleTrackKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.moveByPage(event.key === 'ArrowLeft' ? -1 : 1);
    }

    updateNavigation() {
      if (!this.track) return;
      var maxLeft = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxLeft - 2;
    }
  }

  if (!customElements.get('petes-perks-carousel')) {
    customElements.define('petes-perks-carousel', PetesPerksCarousel);
  }
})();
